import type { SelectOption } from './model/select-option';
import type { State } from './model/state';

export const Alabama = { value: 'AL', label: 'Alabama' };
export const Alaska = { value: 'AK', label: 'Alaska' };
export const Arizona = { value: 'AZ', label: 'Arizona' };
export const Arkansas = { value: 'AR', label: 'Arkansas' };
export const California = { value: 'CA', label: 'California' };
export const Colorado = { value: 'CO', label: 'Colorado' };
export const Connecticut = { value: 'CT', label: 'Connecticut' };
export const Delaware = { value: 'DE', label: 'Delaware' };
export const DistrictOfColumbia = { value: 'DC', label: 'District Of Columbia' };
export const Florida = { value: 'FL', label: 'Florida' };
export const Georgia = { value: 'GA', label: 'Georgia' };
export const Hawaii = { value: 'HI', label: 'Hawaii' };
export const Idaho = { value: 'ID', label: 'Idaho' };
export const Illinois = { value: 'IL', label: 'Illinois' };
export const Indiana = { value: 'IN', label: 'Indiana' };
export const Iowa = { value: 'IA', label: 'Iowa' };
export const Kansas = { value: 'KS', label: 'Kansas' };
export const Kentucky = { value: 'KY', label: 'Kentucky' };
export const Louisiana = { value: 'LA', label: 'Louisiana' };
export const Maine = { value: 'ME', label: 'Maine' };
export const Maryland = { value: 'MD', label: 'Maryland' };
export const Massachusetts = { value: 'MA', label: 'Massachusetts' };
export const Michigan = { value: 'MI', label: 'Michigan' };
export const Minnesota = { value: 'MN', label: 'Minnesota' };
export const Mississippi = { value: 'MS', label: 'Mississippi' };
export const Missouri = { value: 'MO', label: 'Missouri' };
export const Montana = { value: 'MT', label: 'Montana' };
export const Nebraska = { value: 'NE', label: 'Nebraska' };
export const Nevada = { value: 'NV', label: 'Nevada' };
export const NewHampshire = { value: 'NH', label: 'New Hampshire' };
export const NewJersey = { value: 'NJ', label: 'New Jersey' };
export const NewMexico = { value: 'NM', label: 'New Mexico' };
export const NewYork = { value: 'NY', label: 'New York' };
export const NorthCarolina = { value: 'NC', label: 'North Carolina' };
export const NorthDakota = { value: 'ND', label: 'North Dakota' };
export const Ohio = { value: 'OH', label: 'Ohio' };
export const Oklahoma = { value: 'OK', label: 'Oklahoma' };
export const Oregon = { value: 'OR', label: 'Oregon' };
export const Pennsylvania = { value: 'PA', label: 'Pennsylvania' };
export const RhodeIsland = { value: 'RI', label: 'Rhode Island' };
export const SouthCarolina = { value: 'SC', label: 'South Carolina' };
export const SouthDakota = { value: 'SD', label: 'South Dakota' };
export const Tennessee = { value: 'TN', label: 'Tennessee' };
export const Texas = { value: 'TX', label: 'Texas' };
export const Utah = { value: 'UT', label: 'Utah' };
export const Vermont = { value: 'VT', label: 'Vermont' };
export const Virginia = { value: 'VA', label: 'Virginia' };
export const Washington = { value: 'WA', label: 'Washington' };
export const WestVirginia = { value: 'WV', label: 'West Virginia' };
export const Wisconsin = { value: 'WI', label: 'Wisconsin' };
export const Wyoming = { value: 'WY', label: 'Wyoming' };

export const STATE_OPTIONS: State[] = [
    Alabama,
    Alaska,
    Arizona,
    Arkansas,
    California,
    Colorado,
    Connecticut,
    Delaware,
    DistrictOfColumbia,
    Florida,
    Georgia,
    Hawaii,
    Idaho,
    Illinois,
    Indiana,
    Iowa,
    Kansas,
    Kentucky,
    Louisiana,
    Maine,
    Maryland,
    Massachusetts,
    Michigan,
    Minnesota,
    Mississippi,
    Missouri,
    Montana,
    Nebraska,
    Nevada,
    NewHampshire,
    NewJersey,
    NewMexico,
    NewYork,
    NorthCarolina,
    NorthDakota,
    Ohio,
    Oklahoma,
    Oregon,
    Pennsylvania,
    RhodeIsland,
    SouthCarolina,
    SouthDakota,
    Tennessee,
    Texas,
    Utah,
    Vermont,
    Virginia,
    Washington,
    WestVirginia,
    Wisconsin,
    Wyoming,
];

export const ARMY_POST_OFFICE = { value: 'APO', label: 'Army Post Office' };
export const FLEET_POST_OFFICE = { value: 'FPO', label: 'Fleet Post Office' };

export const APO_FPO_OPTIONS: SelectOption[] = [ARMY_POST_OFFICE, FLEET_POST_OFFICE];

export const APO_FPO_REGION_OPTIONS: SelectOption[] = [
    { value: 'AA', label: 'Armed Forces Americas' },
    { value: 'AE', label: 'Armed Forces Europe' },
    { value: 'AP', label: 'Armed Forces Pacific' },
];

export const APO_FPO_REGION_VALUES = APO_FPO_REGION_OPTIONS.map(({ value }) => value);
